import {
  ErrorHandler,
  EnvironmentProviders,
  inject,
  makeEnvironmentProviders,
  provideAppInitializer,
} from '@angular/core';
import { Router } from '@angular/router';
import * as Sentry from '@sentry/angular';
import { environment } from 'src/environments/environment';
import { IEnvironmentConfig } from 'src/environments/environment.type';

// Deployed environments that report to Sentry — local/* and development-test
// runs stay silent (Sentry.capture* calls elsewhere become no-ops when uninitialized).
const SENTRY_ENVIRONMENTS: ReadonlyArray<IEnvironmentConfig['name']> = ['development', 'staging', 'production'];

export function initSentry(): void {
  if (!SENTRY_ENVIRONMENTS.includes(environment.name)) {
    return;
  }

  Sentry.init({
    dsn: 'https://374df546493ddb46da71f0f29256ceaf@o4505348538105856.ingest.us.sentry.io/4511388203810816',
    environment: environment.name,
    sendDefaultPii: true,
    integrations: [
      Sentry.replayIntegration(),
      Sentry.browserTracingIntegration(),
      // Capture console.error() as Sentry events — production and staging only
      ...(environment.name === 'production' || environment.name === 'staging'
        ? [Sentry.captureConsoleIntegration({ levels: ['error'] })]
        : []),
    ],
    tracesSampleRate: environment.production ? 0.2 : 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
}

export function provideSentry(): EnvironmentProviders {
  return makeEnvironmentProviders([
    { provide: ErrorHandler, useValue: Sentry.createErrorHandler() },
    { provide: Sentry.TraceService, deps: [Router] },
    provideAppInitializer(() => void inject(Sentry.TraceService)),
  ]);
}
